import { el, list } from 'redom';

import AddNewItemButton from 'generics/components/add-new-item-buttom';

import {
  getDefaultOptions,
  filterEmptyOptions
} from './utilities';

import OptionInput from './option-input';

class OptionsInputControl {

  constructor(configuration) {

    this.options = getDefaultOptions(configuration.options);
    this.onChange = configuration.onChange;

    this.el = el('.options-input-control-main', [
      el('.options-input-control-option-inputs-container', [
        this.renderOptionInputs()
      ]),
      el('.options-input-control-add-more-option-control-container', [
        new AddNewItemButton({
          label: 'Add option',
          onClick: this.handleAddOptionButtonClick.bind(this)
        })
      ])
    ]);

  }

  renderOptionInputs() {

    this.optionInputsContainer = list('div.options-input-control-option-inputs', OptionInput, null, this);
    this.doUpdateOptionInputs();

    return this.optionInputsContainer;

  }

  handleAddOptionButtonClick() {

    this.options.push('');

    this.doUpdateOptionInputs();

    this.optionInputsContainer.views[this.options.length - 1].nameInput.focus();

  }

  handleOptionChange(index, option) {

    this.options[index] = option;

    this.updateOptionInputs();

  }

  handleOptionDeleteButtonClick(index) {

    this.options.splice(index, 1);

    this.updateOptionInputs();

  }

  doUpdateOptionInputs() {

    this.optionInputsContainer.update(this.options);

  }

  updateOptionInputs() {

    this.doUpdateOptionInputs();

    this.onChange(filterEmptyOptions(this.options));

  }

}

export default OptionsInputControl;